/**
 * Register proj4 defs used by Digisaka GPT crop-field GeoJSON (often UTM WGS84).
 * OpenLayers needs these to reproject orthophoto boundaries onto the map (EPSG:3857).
 */
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';

let baseRegistered = false;

/** UTM WGS84 zones common for Philippines / SEA georeferenced rasters */
const EPSG_DEFS: Record<string, string> = {
  'EPSG:32648': '+proj=utm +zone=48 +datum=WGS84 +units=m +no_defs',
  'EPSG:32649': '+proj=utm +zone=49 +datum=WGS84 +units=m +no_defs',
  'EPSG:32650': '+proj=utm +zone=50 +datum=WGS84 +units=m +no_defs',
  'EPSG:32651': '+proj=utm +zone=51 +datum=WGS84 +units=m +no_defs',
  'EPSG:32652': '+proj=utm +zone=52 +datum=WGS84 +units=m +no_defs',
  'EPSG:32653': '+proj=utm +zone=53 +datum=WGS84 +units=m +no_defs',
  'EPSG:32654': '+proj=utm +zone=54 +datum=WGS84 +units=m +no_defs',
};

export function ensureProjectionsRegistered(crsHint?: string | null): void {
  if (!baseRegistered) {
    register(proj4);
    baseRegistered = true;
  }
  const raw = (crsHint || '').trim();
  if (!raw) return;
  const code = raw.toUpperCase().startsWith('EPSG:') ? raw.toUpperCase() : `EPSG:${raw}`;
  const def = EPSG_DEFS[code];
  if (!def) return;
  proj4.defs(code, def);
}
